import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
} from './StandardInputStyles';

interface Props extends Omit<StandardInputBaseProps, 'value' | 'placeholderText'> {
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  disabled?: boolean;
  description?: string;
}

export default function StandardInputCheckbox({
  id,
  label,
  isRequired,
  checked,
  onChange,
  disabled = false,
  description,
}: Props) {
  return (
    <div className={inputContainerStyles}>
      <div className='flex flex-row items-center gap-3'>
        <div
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '6px',
            border: checked ? 'none' : '2px solid #D1D5DC',
            background: checked ? '#155DFC' : '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            transition: 'background 0.15s',
          }}
          onMouseEnter={(e) => {
            if (!checked && !disabled)
              (e.currentTarget as HTMLDivElement).style.background = '#F3F4F6';
          }}
          onMouseLeave={(e) => {
            if (!checked && !disabled)
              (e.currentTarget as HTMLDivElement).style.background = '#fff';
          }}
          onClick={() => !disabled && onChange?.({ target: { checked: !checked } } as any)}
        >
          {checked && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
            >
              <path
                d='M10 3L4.5 8.5L2 6'
                stroke='white'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )}
          <input
            type='checkbox'
            id={id}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
          />
        </div>

        <div className='flex flex-col'>
          <label
            htmlFor={id}
            className={`${labelStyles} cursor-pointer dark:!text-[#e5e7eb]`}
            style={{ fontWeight: 600 }}
          >
            {label}
            {isRequired && <span className={requiredIndicatorStyles}>*</span>}
          </label>
        </div>
      </div>
      {description && (
        <div
          className='dark:text-[#6A7282]'
          style={{ fontSize: '12px', fontWeight: 500, color: '#99A1AF' }}
        >
          {description}
        </div>
      )}
    </div>
  );
}
